import { ApiGetPharmAddressResponse, ApiPharmAddressResponse } from 'src/app/core/models';

const pharmAddressOne: ApiPharmAddressResponse = {
  customerAddressId: '',
  customerId: '',
  address1: '123 Main Street',
  address2: 'Suite 100',
  city: 'Dallas',
  state: 'TX',
  zipCode: '75201',
};

export const getPharmAddress = (): ApiGetPharmAddressResponse => {
  return pharmAddressOne;
};
